import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type UserV_ListAsAdmin = {
  '@id': string;
  '@type': 'Feedback';
  user: {
    '@id': string;
    '@type': 'User';
    email: string;
    name: string | null;
  };
  message: string;
  category: string;
  submittedAt: string;
  adminNote: string | null;
};

export type UserW = {
  message: string;
  category: string;
};

export type UserW_UpdateAsAdmin = {
  adminNote: string | null;
};

export function useReadCollection(
  queryParams?: { 'order[submittedAt]'?: string; search?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<UserV_ListAsAdmin>>(
    `/feedback${makeQueryString(queryParams)}`,
    options,
  );
}
